import React from 'react';
import Header from './Header';
import Footer from './Footer';

const SafetyPolicy = () => {
  return (
    <div className="min-h-screen bg-offWhite text-charcoal">
      <Header />
      <div className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-4xl font-playfair font-bold mb-8 text-charcoal">Safety Policy</h1>
        
        <div className="prose prose-lg max-w-none text-charcoal/80">
          <p className="text-lg mb-6">
            <strong>Last Updated: April 2026</strong>
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-charcoal mb-4">Child Safety and Abuse Prevention Standards</h2>
            <p className="mb-4">
              Wako is committed to maintaining a safe environment for all users and strictly prohibits child sexual abuse and exploitation (CSAE) in any form.
            </p>
            <p className="mb-4">
              We enforce a zero-tolerance policy against:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Child sexual abuse material (CSAM)</li>
              <li>Grooming or exploitation of minors</li>
              <li>Any content or behavior that endangers minors</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-charcoal mb-4">Reporting System</h2>
            <p className="mb-4">
              Users can report suspicious accounts, messages, or content directly within the Wako app. All reports are reviewed by our moderation team.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-charcoal mb-4">Enforcement Actions</h2>
            <p className="mb-4">
              Violations may result in:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Immediate account suspension or permanent ban</li>
              <li>Content removal</li>
              <li>Reporting to relevant law enforcement authorities where required by law</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-charcoal mb-4">Prevention Measures</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Automated and manual content moderation systems</li>
              <li>User reporting tools integrated in-app</li>
              <li>Ongoing safety monitoring and policy updates</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-charcoal mb-4">Contact</h2>
            <p className="mb-4">
              For child safety concerns or policy inquiries, contact:
            </p>
            <p className="mb-4">
              <a href="mailto:info@orifel.com" className="text-blue-600 hover:text-blue-800">info@orifel.com</a>
            </p>
            <p className="text-sm">
              Wako complies with applicable child safety laws and cooperates with relevant authorities when required.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-charcoal mb-4">Age Verification</h2>
            <p className="mb-4">
              Wako is exclusively for users 18 years of age or older. Our platform implements:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Mandatory age verification during account creation</li>
              <li>Periodic re-verification of user accounts</li>
              <li>Immediate removal of accounts identified as belonging to minors</li>
              <li>Monitoring for accounts attempting to bypass age restrictions</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-charcoal mb-4">User Education & Safety Resources</h2>
            <p className="mb-4">
              We provide resources to help our users stay safe:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Safety tips and best practices available in-app</li>
              <li>Guidance on recognizing and reporting suspicious behavior</li>
              <li>Information about protecting personal information online</li>
              <li>Links to external support and safety organizations</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-charcoal mb-4">Partnership & Cooperation</h2>
            <p className="mb-4">
              Wako works with law enforcement, child safety organizations, and industry partners to combat child exploitation:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Cooperation with law enforcement agencies when required</li>
              <li>Participation in industry safety initiatives</li>
              <li>Regular communication with child protection organizations</li>
              <li>Adherence to international child safety standards</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-charcoal mb-4">Data Protection & Privacy</h2>
            <p className="mb-4">
              User data related to safety and child protection is handled with the highest level of confidentiality and security:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Encryption of sensitive user information</li>
              <li>Restricted access to safety-related data</li>
              <li>Regular security audits and assessments</li>
              <li>Compliance with data protection regulations</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-charcoal mb-4">Transparency & Accountability</h2>
            <p className="mb-4">
              We are committed to transparency in our safety efforts:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Clear communication of safety policies to all users</li>
              <li>Transparent enforcement of violations</li>
              <li>Regular updates to our safety standards</li>
              <li>Accountability for safety decisions and actions</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-charcoal mb-4">Continuous Improvement</h2>
            <p className="mb-4">
              Wako is committed to continuously improving its safety measures:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Regular review and update of safety policies</li>
              <li>Investment in advanced moderation and detection technologies</li>
              <li>Training of moderation teams on latest threats and prevention methods</li>
              <li>Response to emerging child safety challenges and threats</li>
            </ul>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SafetyPolicy;
